import { h } from 'preact';
import WeatherIconSVGData from './weather-svg-icon-data';

const DEFAULTHEIGHT = 32, DEFAULTWIDTH = 32;

export default function WeatherSVGIcon({ name, width=DEFAULTWIDTH, height=DEFAULTHEIGHT, ...props }) {

	let iconData = name && WeatherIconSVGData[name];
	if (!iconData) return null;

	let [ viewboxAttribute, ...paths]  = iconData;

	if (!paths || !paths.length) return null;

	return (
		<svg viewBox={viewboxAttribute} width={width} height={height} {...props} >
			<g>
				{ paths.map( ([fill, d, transform]) => <path fill={fill} d={d}  transform={transform || undefined} />) }
			</g>
		</svg>
	);
}
